<template>
	<form class="s-w-full" @submit.prevent="onSubmit">
		<JBox class="s-p-8">
			<!-- Product name -->
			<CFormInput
				:label="$t('products.name')"
				componentName="JInputText"
				name="name"
				v-bind:class="{ 's-border-red-500': $v.form.name.$error }"
				v-model="$v.form.name.$model"
			/>
			<template v-if="$v.form.name.$dirty">
				<JBox class="s-text-red-500" v-if="!$v.form.name.required">
					{{ $t("products.required") }}
				</JBox>
			</template>

			<!-- Plan -->
			<CFormInput
				:label="$t('products.plan')"
				componentName="JInputText"
				name="plan"
				v-bind:class="{ 's-border-red-500': $v.form.plan.$error }"
				class="s-mt-6"
				v-model="$v.form.plan.$model"
			/>
			<template v-if="$v.form.plan.$dirty">
				<JBox class="s-text-red-500" v-if="!$v.form.plan.required">
					{{ $t("products.required") }}
				</JBox>
			</template>

			<!-- Type -->
			<CFormInput
				:label="$t('products.type')"
				componentName="JInputText"
				name="type"
				class="s-mt-6"
				v-bind:class="{ 's-border-red-500': $v.form.type.$error }"
				v-model="$v.form.type.$model"
			/>
			<template v-if="$v.form.type.$dirty">
				<JBox class="s-text-red-500" v-if="!$v.form.type.required">
					{{ $t("products.required") }}
				</JBox>
			</template>

			<!-- version -->
			<CFormInput
				:label="$t('products.version')"
				componentName="JInputText"
				name="version"
				class="s-mt-6"
				v-bind:class="{ 's-border-red-500': $v.form.version.$error }"
				v-model="$v.form.version.$model"
			/>
			<template v-if="$v.form.version.$dirty">
				<JBox class="s-text-red-500" v-if="!$v.form.version.required">
					{{ $t("products.required") }}
				</JBox>
			</template>

			<!-- Insurer -->
			<CFormInput
				:label="$t('products.insurer')"
				:componentName="CInsurerPicker"
				name="insurerId"
				class="s-mt-6"
				v-model="$v.form.insurerId.$model"
			/>

			<JText class="s-mt-6 s-text-gray-700 s-text-sm s-font-semibold">Add benefits via JSON</JText>
			<JToggle v-model="hasBenefits" />
			<template v-if="hasBenefits">
				<CCodeEditor v-model="form.benefitInputs" />
				<JText class="s-text-red-500" v-if="hasBenefitsErrorMessage">{{ hasBenefitsErrorMessage }}</JText>
			</template>

			<!-- Buttons -->
			<JFlex class="s-justify-between s-mt-8">
				<JButton type="submit" variant="default-light">{{ $t("products.create") }}</JButton>
				<JButton variant="white" @click="$emit('cancel')">{{ $t("products.cancel") }}</JButton>
			</JFlex>
		</JBox>
	</form>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CInsurerPicker from "@/modules/core/components/CInsurerPicker"

const benefitInputsExample = () =>
	JSON.stringify(
		[
			{
				parentTypeId: null,
				typeId: "my_benefit",
				optionKey: undefined,
				parentOptionKeys: undefined,
				currencyCode: "HKD",
				valueJsonString: 1000
			}
		],
		null,
		2
	)

export default {
	props: {
		initialState: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			isLoading: false,
			hasBenefits: false,
			hasBenefitsErrorMessage: null,

			form: {
				name: "",
				plan: "",
				type: "",
				version: "",
				insurerId: "",
				benefitInputs: benefitInputsExample() // JSON as a string
			},

			CInsurerPicker
		}
	},

	validations: {
		form: {
			name: { required },
			plan: { required },
			type: { required },
			version: { required },
			insurerId: {}
		}
	},

	computed: {
		errors() {
			return this.$store.state.products.errors
		}
	},

	methods: {
		async onSubmit() {
			this.$v.$touch()
			if (this.$v.$invalid) return
			this.hasBenefitsErrorMessage = ""

			const form = { ...this.form }
			// Check whether we are including benfitInput
			form.benefitInputs = this.hasBenefits ? this.massageBenefitInputs(this.form.benefitInputs) : undefined

			this.$emit("save", form)
		},

		massageBenefitInputs(benefitInputsAsString) {
			let benefitInputsAsJson = []

			try {
				benefitInputsAsJson = JSON.parse(benefitInputsAsString)
			} catch (e) {
				this.hasBenefitsErrorMessage = "There is a problem with the benefits JSON file"
			}

			// Stringify property `valueJsonString`
			benefitInputsAsJson?.forEach(item => (item.valueJsonString = JSON.stringify(item.valueJsonString)))

			return benefitInputsAsJson
		}
	},

	watch: {
		initialState: {
			handler(newVal) {
				this.form.plan = newVal?.plan
				this.form.type = newVal?.type
				this.form.name = newVal?.name
				this.form.insurerId = newVal?.insurerId
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
